export const REPORT_TABLE_OF_CONTENTS_REORDER_EVENT_NAME = 'reportTableOfContentsReorderEventName';
